<template>
    <div>
        <form @submit.prevent="validate">
            <div class="mb-3">
                <h5>Company Details</h5>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Corporate Registration Type</label>

                            <div v-if="!isEditingCompanyType" class="d-flex align-items-center">
                                <b>
                                    {{ getCompanyTypeByValue(value.companyType) ? getCompanyTypeByValue(value.companyType).text : '' }}
                                </b>
                                <button class="btn btn-outline-success ml-3" type="button" @click="chooseCompanyType">Change</button>
                            </div>

                            <div v-else>
                                <select v-model="value.companyType"
                                    class="form-control">
                                    <option v-for="(type, index) in companyTypes" :key="index" :value="type.value">
                                        {{type.text}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div v-if="isCompanySponsoredType(value.companyType)">
                            <div class="form-group required">
                                <label>Benefit Commencement Date</label>
                                <input ref="inputBenefitCommencementDate" name="inputBenefitCommencementDate" data-vv-as="benefit commencement date" v-model="value.benefitCommencementDate" type="text" class="form-control" data-vv-validate-on="blur" v-validate="'required|date_format:DD/MM/YYYY'" :class="{
                                    'is-invalid':  validationErrors.has('inputBenefitCommencementDate')
                                }" >
                                <div v-show="validationErrors.has('inputBenefitCommencementDate')" class="invalid-feedback">
                                    {{ validationErrors.first('inputBenefitCommencementDate') }}
                                </div>
                                <small>
                                    The date which employee benefits start after company registration.
                                </small>
                            </div>
                            <div class="form-group required">
                                <label>Benefit Refresh Date</label>
                                <div class="row ml-0 mr-0">
                                    <select name="inputBenefitRefreshDay" data-vv-validate-on="blur|input" data-vv-as="benefit refresh date"
                                        v-validate="dateValidation" v-model="benefitRefreshDay" ref="benefitRefreshDay" :class="{
                                        'form-control': true,
                                        'col-4': true,
                                        'is-invalid':  validationErrors.has('inputBenefitRefreshDay')
                                    }">
                                        <option value="01">1</option>
                                        <option value="02">2</option>
                                        <option value="03">3</option>
                                        <option value="04">4</option>
                                        <option value="05">5</option>
                                        <option value="06">6</option>
                                        <option value="07">7</option>
                                        <option value="08">8</option>
                                        <option value="09">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                        <option value="21">21</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28">28</option>
                                        <option value="29" v-if="benefitRefreshMonth!= 2">29</option>
                                        <option value="30" v-if="benefitRefreshMonth!= 2">30</option>
                                        <option value="31" v-if="!monthsWith30Days.includes(benefitRefreshMonth) && benefitRefreshMonth!= 2">31</option>
                                    </select>
                                    <select name="inputBenefitRefreshMonth" v-model="benefitRefreshMonth" @input="revalidateRefreshDate" :class="{
                                        'form-control': true,
                                        'col-8': true,
                                        'is-invalid':  validationErrors.has('inputBenefitRefreshDay')
                                    }">
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    <div v-show="validationErrors.has('inputBenefitRefreshDay')" class="invalid-feedback">
                                        {{ validationErrors.first('inputBenefitRefreshDay') }}
                                    </div>
                                </div>
                                <small>
                                    The anniversary date which employee benefits' annual limit, etc are refreshed to original set amounts on every calendar year. Auto refreshing on subsequent years, unless HR keys in new date.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group required">
                    <label>Company Name</label>
                    <input type="text" name="companyName" data-vv-validate-on="blur" data-vv-as="company name" placeholder="Company Name"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('companyName')
                        }"
                        v-model="value.companyName">
                    <div v-show="validationErrors.has('companyName')" class="invalid-feedback">
                        {{ validationErrors.first('companyName') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Company Registration Number</label>
                    <input type="text" name="companyRegistrationNumber" data-vv-validate-on="blur" data-vv-as="company registration number"
                        :placeholder="`Enter your company registration number`" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('companyRegistrationNumber')
                        }"
                        v-model="value.companyRegistrationId">
                    <small>Example: 0123456789-X</small>

                    <div v-show="validationErrors.has('companyRegistrationNumber')" class="invalid-feedback">
                        {{ validationErrors.first('companyRegistrationNumber') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Contact Person</label>
                    <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                        placeholder="Contact Person" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('contactPerson')
                        }"
                        v-model="value.contactPerson">
                    <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                        {{ validationErrors.first('contactPerson') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Contact Person Email Address</label>
                    <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="contact person email address" v-validate="'required|email'"
                        placeholder="Contact Person Email Address" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('email')
                        }"
                        v-model="value.emailAddress">

                    <div v-show="validationErrors.has('email')" class="invalid-feedback">
                        {{ validationErrors.first('email') }}
                    </div>
                    <small>Please use a company email address.</small>
                </div>

                <div class="form-group required">
                    <label>Contact Person Phone Number</label>
                    <input type="text" name="phoneNumber" data-vv-validate-on="blur" data-vv-as="contact person phone number" placeholder="Contact Person Phone Number"
                        v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('phoneNumber')
                    }"
                        v-model="value.phoneNumber">
                    <div v-show="validationErrors.has('phoneNumber')" class="invalid-feedback">
                        {{ validationErrors.first('phoneNumber') }}
                    </div>
                </div>
                <div class="form-group">
                    <div class="mt-4 mb-2">
                        <b>Company Address</b>
                    </div>
                    <div class="form-group required">
                        <label>Address Line 1</label>
                        <input type="text" name="addressLine1" data-vv-as="address line 1" data-vv-validate-on="blur"
                            placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('addressLine1')
                        }">

                        <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                            {{ validationErrors.first('addressLine1') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Address Line 2</label>
                        <input type="text" class="form-control" placeholder="Address Line 2" v-model="value.addressLine2">
                    </div>

                    <div class="form-group required">
                        <label>City</label>
                        <input type="text" name="city" data-vv-validate-on="blur" placeholder="City" v-model="value.addressCity"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('city')
                        }">
                        <div v-show="validationErrors.has('city')" class="invalid-feedback">
                            {{ validationErrors.first('city') }}
                        </div>
                    </div>

                    <div class="form-group required">
                        <label>State</label>
                        <select name="state" data-vv-validate-on="blur" v-model="value.addressState" v-validate="'required'"
                            :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('state')
                        }">
                            <option :value="null">Choose...</option>
                            <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                {{state.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('state')" class="invalid-feedback">
                            {{ validationErrors.first('state') }}
                        </div>
                    </div>

                    <div class="form-group required">
                        <label>Postal Code</label>
                        <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur" v-model="value.addressPostcode"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('postcode')
                        }">
                        <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                            {{ validationErrors.first('postcode') }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import companyTypes, { getCompanyTypeByValue, isCompanySponsoredType } from '@/config/companyTypes';
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import malaysiaStates from '@/config/malaysiaStates';
export default {
    'name': 'RegisterCompanyComponent',
    'props': {
        'value': Object
    },
    'watch': {
        'value.companyType' (companyType) {
            this.isEditingCompanyType = false;

            if (isCompanySponsoredType(companyType)) {
                this.$nextTick(() => {
                    this.initializeBenefitDatePickers();
                });
            }
        },
        benefitRefreshDate (val) {
            this.value.benefitRefreshDate = val;
        }
    },
    'computed': {
        dateValidation () {
            let maxDay = '31';
            if (this.monthsWith30Days.includes(this.benefitRefreshMonth)) {
                maxDay = '30';
            } else if (this.benefitRefreshMonth === '02') {
                maxDay = '28';
            }

            let result = `required|between:1,${maxDay}`;
            return result;
        },
        monthsWith30Days () {
            return [
                '04', '06', '09', '11'
            ];
        },
        benefitRefreshDate () {
            return `${this.benefitRefreshDay}/${this.benefitRefreshMonth}/${new Date().getFullYear()}`;
        }
    },
    data () {
        return {
            companyTypes,
            malaysiaStates,
            'isEditingCompanyType': false,
            'benefitRefreshDay': '',
            'benefitRefreshMonth': ''
        };
    },
    mounted () {
        if (isCompanySponsoredType(this.value.companyType)) {
            this.initializeBenefitDatePickers();
        }
    },
    'methods': {
        getCompanyTypeByValue,
        isCompanySponsoredType,
        validate () {
            return this.$validator.validateAll();
        },
        initializeBenefitDatePickers () {
            $(this.$refs.inputBenefitCommencementDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.inputBenefitCommencementDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.value.benefitCommencementDate = picker.startDate.format('DD/MM/YYYY');
                }
            );

            // $(this.$refs.inputBenefitRefreshDate).daterangepicker({
            //     'singleDatePicker': true,
            //     'autoApply': true,
            //     'locale': {
            //         'format': 'DD/MM/YYYY'
            //     }
            // });

            // $(this.$refs.inputBenefitRefreshDate).on(
            //     'apply.daterangepicker',
            //     (ev, picker) => {
            //         this.value.benefitRefreshDate = picker.startDate.format('DD/MM/YYYY');
            //     }
            // );
        },
        chooseCompanyType () {
            this.isEditingCompanyType = true;
        },
        revalidateRefreshDate () {
            this.benefitRefreshDay = this.benefitRefreshDay;
        }
    }
};
</script>
